import React, { useEffect } from "react";
import { useState } from "react";
import CommonInputField from "../components/BrandsPartnerComponents/common_input_field";
import EmailIcon from "../components/BrandsPartnerComponents/email_icon";
import CustomDropdown from "../components/BrandsPartnerComponents/dropdownfiled";
import { PartnerType } from "./dtos/partner.dtos";
import { GetCountries } from "../../API/endpoints/Common";
import PhoneInputWithCountryCode from "../components/BrandsPartnerComponents/PhoneFieldWithCountryCode";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import { Form, message } from "antd";
import { set } from "react-hook-form";
type AboutYourBusinessPageType = {
  data: PartnerType;
  setData: React.Dispatch<React.SetStateAction<PartnerType>>;
  previousStep: () => void;
  nextStep: () => void;
  isMobile?: boolean;
};

const AboutYourBusinessPage: React.FC<AboutYourBusinessPageType> = ({
  data,
  setData,
  nextStep,
  previousStep,
  isMobile,
}) => {
  const [countryCodes, setCountryCodes] = useState<any[]>([]);
  const [countries, setCountries] = useState<any[]>([]);
  const [validationError, setValidationError] = useState("");

  const [form] = Form.useForm();
  const handleSubmit = async (values: any) => {
    await form.validateFields();
    // Clear previous validation errors
    setValidationError("");

    // Run validation

    // Validate phone and country code together
    if (data.poc_phone === "" && data.poc_countrycode === "") {
      setValidationError("Country code & Phone number are required.");
      return;
    }
    if (data.poc_countrycode === "" && data.poc_phone !== "") {
      setValidationError("Country code is required.");
      return;
    }
    if (data.poc_countrycode !== "" && data.poc_phone === "") {
      setValidationError("Phone number is required.");
      return;
    }
    if (data.poc_phone.length > 20) {
      setValidationError("Maximum of 20 characters allowed");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (data?.poc_email && !emailRegex.test(data.poc_email)) {
      return;
    }

    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
    if (data?.website && !urlRegex.test(data.website)) {
      return;
    }

    // If all validations pass, update the data state and move to next step
    setData((prev) => ({ ...prev, ...values }));
    nextStep();
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await GetCountries();
        setCountries(
          response.data.map((item: any) => ({
            value: item.id,
            label: item.name,
          }))
        );
        const deduped = response.data.filter(
          (item: any, index: number, self: any[]) =>
            index ===
            self.findIndex((t) => t.country_code === item.country_code)
        );
        setCountryCodes(
          deduped.map((item: any) => ({
            value: item.country_code?.replace(/\s/g, ""),
            label: item.country__alpha_code,
          }))
        );
      } catch (error) {}
    })();
  }, []);

  useEffect(() => {
    if (data.country_of_origin === 0)
      form.setFieldsValue({
        country_of_origin: "",
      });
  }, []);

  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title ">Firstly, Tell Us About Your Business</div>
      <div className="common-sub-text pb-[60px]">
        Tell us about yourself and your journey.
      </div>

      {/* Grid Container */}
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        /* onFinish={(values) => {
          let errorMessage='';
          if (data.poc_phone=== ""&&data.poc_countrycode=== "") {
            errorMessage = "Country code & Phone number is required";
          }
          if (data.poc_countrycode=== ""&&data.poc_phone!== "") {
            errorMessage = "Country code is required";
          }
          if (data.poc_countrycode!== ""&&data.poc_phone=== "") {
            errorMessage = "Phone number is required";
          }
          if (errorMessage!='') {
            setValidationError(errorMessage);
            console.log(errorMessage)
            return;
          }
          setData((prev) => ({ ...prev, ...values }));
          nextStep();
        }} */
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-[16px] gap-y-[16px]">
          {/* Company Name */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="name"
              rules={[
                { required: true, message: "Company Name is required" },
                {
                  max: 50,
                  message: "Maximum of 50 characters allowed",
                },
              ]}
            >
              <CommonInputField
                label="Company Name"
                // placeholder="ABC Ltd"
                value={data.name}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    name: e.target.value,
                  }))
                }
              />
            </Form.Item>
          </div>

          {/* Country of Origin */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="country_of_origin"
              rules={[
                { required: true, message: "Country of Origin is required" },
              ]}
            >
              <CustomDropdown
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    country_of_origin: e as number,
                  }))
                }
                options={countries}
                label="Country of Origin"
                value={
                  data.country_of_origin === 0 ? "" : data.country_of_origin
                }
              />
            </Form.Item>
          </div>

          {/* Website */}
          <div className="col-span-2">
            <Form.Item
              name="website"
              rules={[
                { required: true, message: "Website is required" },
                {
                  type: "url",
                  message: "Enter a valid URL (e.g., https://example.com)",
                },
              ]}
            >
              <CommonInputField
                label="Website"
                type="url"
                // placeholder="ABC Ltd"
                value={data.website}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    website: e.target.value,
                  }))
                }
              />
            </Form.Item>
          </div>

          {/* Key Contact Person */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="poc_name"
              rules={[
                { required: true, message: "Key Contact Person is required" },
              ]}
            >
              <CommonInputField
                label="Key Contact Person"
                // placeholder="John Doe"
                value={data.poc_name}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    poc_name: e.target.value,
                  }))
                }
              />
            </Form.Item>
          </div>

          {/* Designation */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="poc_designation"
              rules={[
                { required: true, message: "Designation is required" },
                {
                  max: 20,
                  message: "Maximum of 20 characters allowed",
                },
              ]}
            >
              <CommonInputField
                label="Designation"
                // placeholder="Brand Manager"
                value={data.poc_designation}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    poc_designation: e.target.value,
                  }))
                }
              />
            </Form.Item>
          </div>

          {/* Email */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="poc_email"
              rules={[{ required: true, message: "Email is required" }]}
            >
              <CommonInputField
                label="Email"
                type="email"
                prefix={
                  <div className="pr-[8px]">
                    <EmailIcon />
                  </div>
                }
                // placeholder="john.doe@example.com"
                value={data.poc_email}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    poc_email: e.target.value,
                  }))
                }
              />
            </Form.Item>
          </div>

          {/* Phone */}

          <div className="col-span-2 md:col-span-1">
            <PhoneInputWithCountryCode
              label="Phone"
              error={validationError}
              countryCode={data.poc_countrycode || ""}
              onCountryCodeChange={(e) =>
                setData((curret) => ({
                  ...curret,
                  poc_countrycode: e,
                }))
              }
              phoneNumber={data.poc_phone}
              onPhoneNumberChange={(e) =>
                setData((curret) => ({
                  ...curret,
                  poc_phone: e,
                }))
              }
              countryOptions={countryCodes}
            />
          </div>
        </div>
      </Form>
      {/* Desktop Next/Previous Navigation */}
      {!isMobile && (
        <div className="mt-[60px]   inline-flex flex justify-start gap-x-[8px] w-full md:w-auto">
          <NavigationButton
            onClick={previousStep}
            label="Previous"
            type="text"
          />

          <NavigationButton
            onClick={() => {
              form.submit();
              handleSubmit(data);
            }}
            label={"Next"}
            type="primary"
          />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-4 py-4 gap-x-2 w-full shadow-lg z-20 bg-white">
          {
            <NavigationButton
              onClick={previousStep}
              label="Previous"
              type="text"
              block
            />
          }
          <NavigationButton
            onClick={() => {
              form.submit();
              handleSubmit(data);
            }}
            label={"Next"}
            type="primary"
            block
          />
        </div>
      )}
    </div>
  );
};

export default AboutYourBusinessPage;
